import React from "react";
import { Outlet } from "react-router";

import GovernmentBanner from "../components/GovernmentBanner";
import Header from "../components/Header";
import Footer from "../components/Footer/Footer";

import "./GuestLayout.css";

const GuestLayout = () => {
  return (
    <div
      className="dga-guest-app"
      dir="rtl"
    >
      <GovernmentBanner />

      <Header hideLoginButton />

      <main className="dga-guest-content">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default GuestLayout;